export default "__VITE_ASSET__BzGkzDCU__"